import * as React from 'react';
import { createViewConfig, view } from '@sail/engine';
import { GridLines } from '../GridLines/GridLines';
import { styles } from './SiteHeaderStyles';
import { StripeLogo } from '../StripeLogo/StripeLogo';
import { useHelmTheme } from '../../hooks/useHelmTheme';
export const SiteHeaderConfig = createViewConfig({
    props: {},
    name: 'SiteHeader'
});
/**
 * The header component used to render the stripe logo and navigation
 */ export const SiteHeader = SiteHeaderConfig.createView(({ theme, ...props })=>{
    const themeTokenOverrideIntents = useHelmTheme({
        theme
    });
    return /*#__PURE__*/ React.createElement(view.header, {
        ...props,
        uses: [
            styles.siteHeader,
            ...themeTokenOverrideIntents
        ]
    }, /*#__PURE__*/ React.createElement(view.div, {
        uses: [
            styles.siteHeaderGridLinesContainer
        ]
    }, /*#__PURE__*/ React.createElement(GridLines, null)), /*#__PURE__*/ React.createElement(view.div, {
        uses: [
            styles.siteHeaderContainer
        ]
    }, /*#__PURE__*/ React.createElement(view.div, {
        uses: [
            styles.siteHeaderNavContainer
        ]
    }, /*#__PURE__*/ React.createElement(view.h1, {
        uses: [
            styles.siteHeaderLogo
        ]
    }, /*#__PURE__*/ React.createElement(view.a, {
        uses: [
            styles.siteHeaderLogoLink
        ],
        href: "/",
        "data-js-controller": "AnalyticsButton",
        "data-analytics-category": "Navigation",
        "data-analytics-action": "Clicked",
        "data-analytics-label": "Stripe Logo",
        "data-testid": "header-stripe-logo"
    }, /*#__PURE__*/ React.createElement(StripeLogo, null))))));
});

//# sourceMappingURL=SiteHeader.js.map